<template>
    <component :is="layout">
        <router-view></router-view>
    </component>
</template>


<script>
    const default_layout = 'container';
    import LayoutsContainer from '@/views/layouts/Container';
    import LayoutsVideo from '@/views/layouts/Video';

    export default {
        components: {
            LayoutsContainer, LayoutsVideo
        },
        computed: {
            layout() {
                return 'layouts-' + (this.$route.meta.layout || default_layout);
            }
        }
    }
</script>

<style lang="scss">
    $fa-font-path: '~font-awesome/fonts/';
    @import '~font-awesome/scss/font-awesome.scss';
    @import 'src/assets/scss/_variables';
    @import '~bootstrap/scss/bootstrap';
    @import 'src/assets/scss/style';
</style>
